var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8AA5AF",
    d: "M10,19.984375 C12.75,19.984375 15.1015625,19.0078125 17.0546875,17.0546875 C19.0078125,15.1015625 19.984375,12.75 19.984375,10 C19.984375,7.25 19.0078125,4.8984375 17.0546875,2.9453125 C15.1015625,0.9921875 12.75,0.015625 10,0.015625 C7.25,0.015625 4.890625,1 2.921875,2.96875 C0.984375,4.90625 0.015625,7.25 0.015625,10 C0.015625,12.75 0.9921875,15.1015625 2.9453125,17.0546875 C4.8984375,19.0078125 7.25,19.984375 10,19.984375 Z M10,18.015625 C7.8125,18.015625 5.921875,17.234375 4.328125,15.671875 C2.765625,14.078125 1.984375,12.1875 1.984375,10 C1.984375,7.8125 2.7734375,5.9296875 4.3515625,4.3515625 C5.9296875,2.7734375 7.8125,1.984375 10,1.984375 C12.1875,1.984375 14.0703125,2.7734375 15.6484375,4.3515625 C17.2265625,5.9296875 18.015625,7.8125 18.015625,10 C18.015625,12.1875 17.2265625,14.0703125 15.6484375,15.6484375 C14.0703125,17.2265625 12.1875,18.015625 10,18.015625 Z M14.265625,14.171875 L15.015625,12.90625 L10.515625,10.234375 L10.515625,4.984375 L9.015625,4.984375 L9.015625,10.984375 L14.265625,14.171875 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.227ed98d41e28f4e60ac0199de6b6cb1.svg";
export { ForwardRef as ReactComponent };